import "./button.css";

const Button = ({ className, href, children, target, rel }) => {
  const safeRel =
    rel || (target === "_blank" ? "noopener noreferrer" : undefined);

  return (
    <a href={href} className={className} target={target} rel={safeRel}>
      {children}
    </a>
  );
};

export default Button;
